import * as React from "react"

import { LocalPhoneProvider } from "../src/context/local-phone"

// Area pages carry the per-city phone in pageContext.localPhone (E.164).
// Every other page falls through to the Austin default inside the provider.
export const wrapPageElement = ({ element, props }: any) => (
  <LocalPhoneProvider e164={props?.pageContext?.localPhone}>
    {element}
  </LocalPhoneProvider>
)
